import { useState } from "react";
import { plotPoints } from "@/mocks/content";

export default function PlotSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="plot" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="max-w-2xl" data-reveal>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            剧情看点：这类故事通常怎么讲
          </h2>
          <p className="mt-3 text-foreground-600 leading-8">
            与其复述某一部的剧情，不如看看这个题材共通的叙事方式。
            下面六条要点分别对应情感、冲突、成长、悬念、群像与结局，点击可展开细读。
          </p>
        </div>

        <div className="mt-8 space-y-3 max-w-3xl">
          {plotPoints.map((p, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={p.title}
                data-reveal
                className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="w-full flex items-center gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
                >
                  <span className="font-heading text-sm text-primary-600 w-6 shrink-0">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 font-medium text-foreground-900">{p.title}</span>
                  <i
                    className={
                      isOpen
                        ? "ri-subtract-line text-xl text-foreground-500"
                        : "ri-add-line text-xl text-foreground-500"
                    }
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[3.75rem]">
                    <p className="text-sm text-foreground-600 leading-7">{p.text}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}